import type { ExcelDownloadClient, ExcelDownloadResult } from "app/components/React/ExcelButton/ExcelClientDownload";
import type {
    AppsExcelDownloadRequestDto,
    AppsSearchRequestDto,
    AppsSearchResponseDto,
} from "app/pages/sales-intelligence/modules/apps-search/types/dto";
import type { IFetchService, PostConfigObject } from "app/services/fetchService";

import { BASE_ENDPOINT_PATH } from "./const";

export const createAppsApiService = (fetchService: IFetchService, excelDownloadClient: ExcelDownloadClient) => {
    const baseAppsPath = `${BASE_ENDPOINT_PATH}/apps`;

    return {
        fetchSearchResults(dto: AppsSearchRequestDto, config?: PostConfigObject): Promise<AppsSearchResponseDto> {
            return fetchService.post(baseAppsPath, dto, config);
        },

        exportToExcel(dto: AppsExcelDownloadRequestDto): Promise<ExcelDownloadResult> {
            return excelDownloadClient(`${baseAppsPath}/excel`, dto);
        },
    };
};
